
export const serviceAreaColors = [
	'#000000',
	'#2C9A00',
	'#FF3800',
	'#C000FF',
	'#E27B00'
];
